import {
	Autocomplete,
	Avatar,
	Box,
	CircularProgress,
	ListItem,
	ListItemText,
	TextField,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import debounce from "lodash.debounce";

export const FilterAutocomplete = ({
	label,
	name,
	fetchOptions,
	handleChange,
	reset,
	setReset,
	allowed_to_cart = false,
}) => {
	const [options, setOptions] = useState([]);
	const [option, setOption] = useState(null);
	const [inputValue, setInputValue] = useState("");
	const [loading, setLoading] = useState(false);

	// Debounced fetch inside useMemo to avoid recreation on every render
	const debouncedFetch = useMemo(
		() =>
			debounce(async (query) => {
				setLoading(true);

				try {
					const res = await fetchOptions(10, 1, {
						search: query,
						...(allowed_to_cart && { allowed_to_cart }),
					});
					setOptions(res.results || []);
				} catch (err) {
					console.error("Failed to fetch options:", err);
					setOptions([]);
				} finally {
					setLoading(false);
				}
			}, 500),
		[allowed_to_cart, fetchOptions]
	);

	// Clean up debounce on unmount
	useEffect(() => {
		return () => {
			debouncedFetch.cancel();
		};
	}, [debouncedFetch]);

	// Notify parent on selection change
	useEffect(() => {
		// if (option) {
		// Prevent initial null state from clearing an existing popup during edit.
		  if (name === "popup" && option === null) {
    return;
  }
		handleChange(name, option);
		// }
	}, [handleChange, name, option]);

	// Reset logic
	useEffect(() => {
		if (reset) {
			setInputValue("");
			setOption(null);
			setOptions([]);
			setReset(false);
		}
	}, [reset, setReset]);

	const renderOption = (props, option) => {
		let primary = option?.title || "";

		switch (name) {
			case "playoff":
				primary = option?.title;

				break;

			case "product_category":
				primary = `${option.name} ${option.products_count ? `(${option.products_count})` : ""
					}`;
				break;

			case "seller":
				primary = option?.name;

				break;

			case "brand":
				primary = option?.name;
				break;
			case "bucket":
				primary = option?.name;
				break;

			default:
				primary = option?.title || "";
		}

		return (
			<ListItem {...props} key={option.id}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
					<Avatar
						src={option.image?.file || ""}
						alt={option.title}
						sx={{ width: 30, height: 30, bgcolor: "#003B6D" }}
					/>
					<ListItemText primary={primary} />
				</Box>
			</ListItem>
		);
	};

	return (
		<Autocomplete
			freeSolo
			options={options}
			loading={loading}
			value={option}
			inputValue={inputValue}
			getOptionLabel={(option) =>
				typeof option === "string"
					? option
					: option?.name
						? option?.name
						: option?.title || ""
			}
			clearOnEscape={true}
			isOptionEqualToValue={(option, value) => option?.id === value?.id}
			onInputChange={(e, input) => {
				setInputValue(input);
				if (input?.length > 0) {debouncedFetch(input);}
			}}
			onClose={() => {
				setInputValue("");
				setOptions([]);
				// setOption(null); // optional, depends if you want to clear selection too
			}}
			onChange={(e, newValue) => setOption(newValue)}
			renderOption={renderOption}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{loading && (
									<CircularProgress
										color="inherit"
										size={20}
									/>
								)}
								{params.InputProps.endAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
};
